/**
 * 电台清单（数据，不是代码）
 * ============================================================
 * 学方言要「多听多说」，电台是「多听」最自然的载体。
 * 流地址极易失效，所以单独放这里：换地址只改这份数据，不动组件。
 *
 * status 语义：
 *   online  —— 已验证能播，前端正常加载
 *   offline —— 暂未接入或流已失效，前端显示「暂不可用」，绝不假装能播
 *
 * 当前只有粤语两个台。其它方言的电台接入情况（2026-10-18 核实的结论）：
 *   · 上海戏曲 / 泉州刺桐 —— 蜻蜓流无 CORS 且代理后仍不稳，已移除，待官方源
 *   · 陕西 —— 秦腔广播已停播，无纯陕西话台（农村广播是普通话）
 *   · 南京 / 潮汕 —— 地方台流未公开，需官方 App 抓包（不稳定 + 合规风险）
 */
export const STATIONS = [
  {
    id: 'rthk1',
    name: '香港电台第一台',
    dialect: '粤语',
    freq: 'RTHK Radio 1',
    streamUrl: 'https://rthkradio1-live.akamaized.net/hls/live/2035313/radio1/master.m3u8',
    status: 'online',
    desc: '粤语新闻与时事主频道，全天粤语播音，语料最标准，适合练听力。',
  },
  {
    id: 'rthk2',
    name: '香港电台第二台',
    dialect: '粤语',
    freq: 'RTHK Radio 2',
    streamUrl: 'https://rthkradio2-live.akamaized.net/hls/live/2040078/radio2/master.m3u8',
    status: 'online',
    desc: '粤语综艺与流行音乐频道，语速较轻松，适合日常磨耳朵、习惯粤语节奏。',
  },
];
